/*
  mountainFLOW: prev/next arrows for the collection tabs on small screens.

  The tab row scrolls horizontally on a phone, so tabs off to the side are easy to miss.
  These step through them instead.

  Rather than setting `selected-index` directly, the target tab button is clicked, so
  TabsElement runs its whole switch -- panel transition, motion list, and the deferred
  section fetch on the api-button inside each tab.
*/
(() => {
  const bind = (nav) => {
    if (nav.dataset.mfBound) return;
    nav.dataset.mfBound = '1';

    const tabs = document.getElementById(nav.getAttribute('aria-controls'));
    if (!tabs) return;

    const buttons = () => Array.from(tabs.querySelectorAll('button[role="tab"]'));
    const current = () => parseInt(tabs.getAttribute('selected-index'), 10) || 0;

    const sync = () => {
      const i = current();
      const last = buttons().length - 1;
      nav.querySelectorAll('[data-tab-nav]').forEach((b) => {
        const isPrev = b.dataset.tabNav === 'prev';
        b.disabled = isPrev ? i <= 0 : i >= last;
      });
    };

    nav.querySelectorAll('[data-tab-nav]').forEach((b) => {
      b.addEventListener('click', () => {
        const list = buttons();
        const next = current() + (b.dataset.tabNav === 'prev' ? -1 : 1);
        if (next < 0 || next > list.length - 1) return;
        list[next].click();
      });
    });

    // TabsElement reflects the selection onto the attribute, so observing it keeps the
    // arrows in step whether the change came from a tab or from these buttons.
    new MutationObserver(sync).observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });
    sync();
  };

  const scan = (root) => (root || document).querySelectorAll('[data-tab-nav-group]').forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
